module.exports = __webpack_public_path__ + "img/right3.14b5f70b.png";